var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclein2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 488,
    viewBox: "0 0 488 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.729 40.4265C240.701 38.4635 242.269 36.8461 244.233 36.8514C246.196 36.8566 247.755 38.4824 247.717 40.4451L247.266 63.2577C247.233 64.9431 245.84 66.2797 244.154 66.2752C242.468 66.2707 241.082 64.9267 241.058 63.2411L240.729 40.4265Z",
    fill: "#BEDFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.554 244.055C451.554 358.93 358.429 452.055 243.554 452.055C128.679 452.055 35.5542 358.93 35.5542 244.055C35.5542 129.179 128.679 36.0545 243.554 36.0545C358.429 36.0545 451.554 129.179 451.554 244.055ZM66.7542 244.055C66.7542 341.698 145.91 420.854 243.554 420.854C341.198 420.854 420.354 341.698 420.354 244.055C420.354 146.411 341.198 67.2545 243.554 67.2545C145.91 67.2545 66.7542 146.411 66.7542 244.055Z",
    fill: "#3B3D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.897 49.7051C228.309 41.9955 234.085 35.2192 241.817 35.1501C265.785 34.936 289.646 38.8626 312.34 46.7913C339.446 56.2616 364.301 71.2368 385.34 90.7756C406.38 110.314 423.151 133.994 434.598 160.327C446.045 186.659 451.921 215.075 451.857 243.788C451.793 272.501 445.79 300.89 434.225 327.171C422.66 353.452 405.784 377.057 384.657 396.501C363.53 415.946 338.609 430.81 311.461 440.159C288.732 447.986 264.853 451.806 240.886 451.485C233.155 451.381 227.409 444.579 228.032 436.872L228.289 433.698C228.911 425.991 235.669 420.306 243.401 420.318C263.073 420.349 282.646 417.1 301.307 410.673C324.389 402.725 345.576 390.088 363.539 373.556C381.501 357.024 395.849 336.955 405.681 314.611C415.514 292.267 420.618 268.13 420.672 243.718C420.727 219.306 415.731 195.147 405.999 172.759C396.266 150.371 382.008 130.239 364.12 113.627C346.232 97.0147 325.1 84.2827 302.055 76.2311C283.422 69.7213 263.864 66.3847 244.193 66.3274C236.461 66.3048 229.728 60.5902 229.14 52.8807L228.897 49.7051Z",
    fill: "#BEDFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 436.354,
    r: 15.5,
    fill: "#BEDFFF",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 51.5544,
    r: 15.5,
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclein2);
export default __webpack_public_path__ + "static/media/circlein2.2be29a584825a1384c914b0903f412e1.svg";
export { ForwardRef as ReactComponent };